module.exports = new __parcel__URL__("benefits_0.8d07fbfe.webp").toString();